<template>
  <footer class="footer">
    <div class="footer__bottom"><small class="footer__copyright">Copyright U-CAN, INC. All Rights Reserved.</small></div>
  </footer>
</template>


<script>
export default {
  name: 'Footer',
}
</script>


<style scoped>
</style>